import { action } from 'satcheljs/lib/legacy';
export default action('setIsPlaceholderAttachment')(function setIsPlacholderAttachment(attachment, isPlaceholder) {
    attachment.isPlaceholderAttachment = isPlaceholder;
});
//# sourceMappingURL=setIsPlaceholderAttachment.js.map